module.exports = __webpack_public_path__ + "static/media/img1.9ce1e4b0.jpeg";